module.exports = __webpack_public_path__ + "static/media/w (14).620c3d7f.jpg";